<template>
  <button
    title="CamelCamelCamel"
    type="button"
    class="btn btn-icon p-half btn-warning"
    @click="handleClick"
  >
    <i class="icon-psh-camelcamelcamel text-danger fs-4"></i>
  </button>
</template>
<script>
export default {
  name: 'CamelButton',
  props: {
    asin: {
      type: String,
      default: '',
    },
  },
  methods: {
    handleClick() {
      const url = `https://camelcamelcamel.com/product/${this.asin}`
      window.open(url, '_blank')
    },
  },
}
</script>
<style scoped>
</style>
